import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export type SanitizeType = 'URL' | 'HTML' | 'RESOURCE_URL' | 'STYLE' | 'SCRIPT';

@Pipe({
  name: 'sanitize',
  pure: true,
})
export class SanitizePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(value: string, type: SanitizeType) {
    switch (type) {
      case 'HTML':
        return this.domSanitizer.bypassSecurityTrustHtml(value);
      case 'URL':
        return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
      case 'STYLE':
        return this.domSanitizer.bypassSecurityTrustStyle(value);
      case 'SCRIPT':
        return this.domSanitizer.bypassSecurityTrustScript(value);
      case 'RESOURCE_URL':
        return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
    }
  }
}
